import React, { useState, useEffect } from "react";
import { ReactComponent as IconPlus } from "../../layout/others/icon_plus.svg";
import { InterviewService } from "../../services/InterviewService";
import { useInterviewContext } from "./InterviewContext";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import "../Interview/Interview.scss";
import "../styles/header.scss";
import ModalAlertToCloneInterview from "./ModalAlertToCloneInterview";
import ConversationIcon from "../../layout/left_menu_icons/conversation.svg";
import ScreenCallIcon from "../../layout/other_icons/ScreenCall_icon.svg";
import { ReactComponent as IconExclamation } from "../../layout/others/icon_alert_exclamation.svg";
import SelectedTag from "../../components/Tags/SelectedTag";

const InterviewHeader = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const {
    submitForm,
    interview,
    setInterview,
    setIsLoading,
    isTabsDisabled,
    saveWithOutValidateInterview
  } = useInterviewContext();
  const [showModalCloneInterview, setShowModalCloneInterview] = useState(false);
  const INTERVIEW = 1;

  function refreshInterviewList() {
    if (window.opener)
      window.opener.postMessage("INTERVIEWLISTREFRESH", window.location.origin);
  }

  const onClickNewInterview = () => {
    setShowModalCloneInterview(false);
    setIsLoading(true);

    InterviewService.cloneLastInterview(interview.interviewId).then(
      (interviewClone) => {
        if (!interviewClone.error) {
          Promise.all([
            InterviewService.getEducationInterview(interviewClone.interviewId),
            InterviewService.getTechnologiesInterview(
              interviewClone.interviewId
            ),
            InterviewService.getSkillsInterview(interviewClone.interviewId)
          ])
            .then(([educationData, technologiesData, skillsData]) => {
              setInterview({
                ...interviewClone,
                interviewEducation: educationData,
                technologies: technologiesData,
                skills: skillsData
              });
              refreshInterviewList();
            })
            .catch((err) => console.error(err))
            .finally(() => {
              setIsLoading(false);
            });
        }
      }
    );
  };

  useEffect(() => {
    document.title = interview.personalInformation.fullName;
  }, [interview.personalInformation.fullName]);

  useEffect(() => {
    if (history.action === "POP") {
      history.goBack();
    }
  }, [history.action]);

  const goBackToInterview = () => {
    history.goBack();
  };

  function GetHeaderTitle() {
    if (interview.typeOfInterview === INTERVIEW) {
      return `${t("Interview - Nº")} ${interview.interviewOrderSequence} / ${
        interview.totalInterviews
      } ${
        interview.personalInformation.fullName &&
        ` - ${interview.personalInformation.fullName} - `
      }(${t("Created on")} ${` :`} ${interview.createdDate})`;
    } else if (interview.typeOfInterview === 2) {
      return `${t("Screen Call")}  ${
        interview.personalInformation.fullName &&
        ` - ${interview.personalInformation.fullName} - `
      }(${t("Created on")} ${` :`} ${interview.createdDate})`;
    } else {
      return `${t("Interview - Nº 1/1 ")}  ${
        interview.personalInformation.fullName &&
        `-
        ${interview.personalInformation.fullName}`
      }
        `;
    }
  }

  function getHeaderIcon() {
    if (interview.typeOfInterview === 1) {
      return <img src={ConversationIcon} alt="ni-icon" />;
    } else if (interview.typeOfInterview === 2) {
      return <img src={ScreenCallIcon} alt="ni-icon" />;
    }
  }

  function getBreadCrumbleInterview() {
    if (interview.typeOfInterview === 1) {
      return <div className="subtitle">{t("Recruitment / New Interview")}</div>;
    } else if (interview.typeOfInterview === 2) {
      return <div className="subtitle">{t("Recruitment / New Interview")}</div>;
    }
  }

  return (
    <>
      {" "}
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            {getHeaderIcon()}
            <h1 style={{ marginTop: "10px" }}>
              {GetHeaderTitle()}
              {!interview.isFinalized && (
                <IconExclamation
                  className="icon-exclamation-size"
                  title={t("Incomplete Interview")}
                />
              )}
            </h1>
          </div>{" "}
          <h4 className="fw-bold">{interview.formerCompany}</h4>
          {getBreadCrumbleInterview()}
        </div>
        <div>
          <div className="text-end col-auto">
            <a
              href="#!"
              className="btn app-button btn-second btn-lg"
              onClick={() => goBackToInterview()}
            >
              {t("Back")}
            </a>
            {interview.interviewId === 0 ||
            (interview.interviewId !== 0 &&
              (interview.isFinalized === undefined ||
                interview.isFinalized === false)) ? (
              <button
                type="button"
                disabled
                className="app-button btn-disabled btn-lg"
              >
                <IconPlus /> {t("Interview")}
              </button>
            ) : (
              <button
                type="button"
                onClick={() => setShowModalCloneInterview(true)}
                disabled={isTabsDisabled}
                className="app-button btn-second btn-lg"
              >
                <IconPlus /> {t("Interview")}
              </button>
            )}
            <button
              disabled={isTabsDisabled}
              onClick={
                interview.typeOfInterview === INTERVIEW
                  ? submitForm
                  : saveWithOutValidateInterview
              }
              className="app-button btn-prime btn-lg"
            >
              {t("Done")}
            </button>
          </div>{" "}
        </div>
        <ModalAlertToCloneInterview
          showModal={showModalCloneInterview}
          setShowModal={setShowModalCloneInterview}
          submitButtonAction={onClickNewInterview}
        />{" "}
      </header>
      <SelectedTag interviewTag={interview.tags} />
    </>
  );
};

export default InterviewHeader;
